import { Prop, Vue, Watch } from 'vue-property-decorator';

import { VueConstructor } from 'vue';
import Component from 'vue-class-component';
import SeckillSketch from './seckill-sketch.vue';
import SeckillGroupSketch from './seckillGroup-sketch.vue';
import GroupSketch from './group-sketch.vue';
import ShareCardSketch from './share-card-sketch.vue';
import SharePosterSketch from './share-poster-sketch.vue';

import style from './style.vue';

/**
 * 此组件接收2个参数
 *
 * componentKeys: string[] 需渲染预览组件的key(keyList中添加)
 *
 * sketchData: any[] 传入的预览的数据，与传入key数组的下标相对应，按顺序传入组件
 *
 */

type keyList = 'secKill' | 'shareCard' | 'sharePoster' | 'group' | 'seckillGroup';

const componentsList = {
  secKill: SeckillSketch,
  group: GroupSketch,
  shareCard: ShareCardSketch,
  sharePoster: SharePosterSketch,
  seckillGroup: SeckillGroupSketch,
};

@Component({
  components: { SeckillSketch, ShareCardSketch, SharePosterSketch, SeckillGroupSketch },
  mixins: [style],
})
export default class Sketch extends Vue {
  @Prop()
  componentKeys: keyList[];

  @Prop({ default: [] })
  sketchData: any[];

  @Prop({ default: true })
  showAddress: boolean;

  @Prop({ default: '' })
  logo: string;

  @Prop({ default: () => [] })
  sketchGroupImgs: string[];

  @Prop({ default: ()=>{} })
  displayConfig: ItemObject

  @Prop({ default: '立即秒杀' })
  buttonName: string

  @Watch('sketchGroupImgs', { deep: true })
  watchSketchGroupImgs(n, o) { }

  render(h) {
    return (
      <div class="sketch-component">
        {this.componentKeys.map((item, index) => {
          const Com: any = componentsList[item];
          return (
            <Com
              {...{
                props: {
                  data: this.sketchData[index],
                  displayConfig: this.displayConfig,
                  buttonName: this.buttonName,
                  showAddress: this.showAddress,
                  logo: this.logo,
                  sketchGroupImgs: this.sketchGroupImgs,
                },
              }}
            />
          );
        })}
      </div>
    );
  }
}
